export default "__VITE_ASSET__44bbad58__"